import { render, staticRenderFns } from "./Popin.vue?vue&type=template&id=0252fc0c"
import script from "./Popin.vue?vue&type=script&lang=js"
export * from "./Popin.vue?vue&type=script&lang=js"
import style0 from "./Popin.vue?vue&type=style&index=0&id=0252fc0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports